import React from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useAuth } from "../../hooks/useAuth";
import { T, useTranslateKey } from "../../hooks/useTranslate";
import { useMixPanel } from "../../hooks/useMixPanel";
import { Typography } from "@unicity/design-system";
import {
  Box,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

const COACHING_URL = process.env.REACT_APP_FEEL_GREAT_COACHING_URL;

const FeelGreatCoachingNavItem = ({
  open,
  isMobile,
  drawerOpen,
  toggleDrawer,
}) => {
  const { userInfo } = useAuth();
  const flags = useFlags();
  const { logEvent } = useMixPanel();
  const translatedTitle = useTranslateKey("feel_great_coaching");

  // LD flag: release variation — value is an array of allowed distributor IDs
  const allowedIds = flags.feelGreatCoachingAllowedIds || [];

  const isAllowed =
    userInfo?.loggedIn &&
    userInfo?.unicityId &&
    Array.isArray(allowedIds) &&
    allowedIds.includes(String(userInfo.unicityId));

  if (!isAllowed) return null;

  const handleClick = () => {
    logEvent("feel_great_coaching_view", { location: "menu" });
    if (isMobile && toggleDrawer) {
      toggleDrawer();
    }
    window.open(COACHING_URL, "_blank");
  };

  const isOpen = isMobile ? drawerOpen : open;

  return (
    <ListItem
      id="feel-great-coaching-nav-item"
      data-test-id="feel-great-coaching-nav-item"
      title={translatedTitle}
      aria-label="feel_great_coaching"
      onClick={handleClick}
      disablePadding
      sx={{ display: "block" }}
    >
      <ListItemButton
        sx={{
          minHeight: 48,
          justifyContent: isOpen ? "initial" : "center",
          px: isMobile ? 1.2 : 2.5,
          mb: isMobile ? "0px" : "10px",
          cursor: "pointer",
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: isOpen ? 3 : "auto",
            justifyContent: "center",
          }}
        >
          <img
            style={{ display: "inline-block" }}
            src="icons/feel-great-coaching-icon.svg"
            alt="feel great coaching icon"
          />
        </ListItemIcon>
        <ListItemText
          primary={
            <Box sx={{ display: "flex", gap: "6.5px" }}>
              <Typography
                variant={isMobile ? "caption" : "menuItem"}
                sx={{ display: "inline" }}
              >
                <T>feel_great_coaching</T>
              </Typography>
            </Box>
          }
          primaryTypographyProps={{
            fontFamily: "Inter",
            fontWeight: "600",
            fontSize: isMobile
              ? "calc(12px * var(--unicity-font-scale, 1))"
              : "12px",
          }}
          sx={{ opacity: isOpen ? 1 : 0 }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export { FeelGreatCoachingNavItem };
